import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CheckMobile from './pages/CheckMobile';
import TemplateWiseReport from './pages/TemplateWiseReport';
import EmailMonitoring from './pages/EmailMonitoring';
import SubjectWiseReport from './pages/SubjectWiseReport';
import TrafficSummary from './pages/TrafficSummary';
import FailureAnalysis from './pages/FailureAnalysis';
import TextToSpeech from './components/Tts';
import { canAccessPage, getUserPermissions } from './utils/permissions';
import EmailSubmitted from './pages/EmailSubmitted';
import EmailDateSummary from './pages/EmailDateSummary';
import './App.css';
import LoginPage from './pages/group/pages/LoginPage';
import GroupList from './pages/group/pages/GroupList';
import UserChat from './pages/group/pages/Userchat/userchat';

function App() {
  const permissions = getUserPermissions();

  const ProtectedRoute = ({ element, page }) => {
    if (!canAccessPage(page, permissions)) {
      return <Navigate to="/number" replace />;
    }

    return element;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/tts" element={<TextToSpeech />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/template" element={<TemplateWiseReport />} />
        <Route path="/email-monitoring" element={<ProtectedRoute element={<EmailMonitoring />} page="email-monitoring" />} />
        <Route path="/subject-wise-report" element={<ProtectedRoute element={<SubjectWiseReport />} page="subject-wise-report" />} />
        <Route path="/number" element={<CheckMobile />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/traffic" element={<TrafficSummary />} />
        <Route path="/failure" element={<FailureAnalysis />} />
        <Route path="/emailSubjectWiseReport" element={<ProtectedRoute element={<EmailSubmitted />} page="email-subject_summary" />} />
        <Route path="/emailSummary" element={<ProtectedRoute element={<EmailDateSummary />} page="email-date-summary" />} />

        <Route path="/group/login" element={<ProtectedRoute element={<LoginPage />} />} />
        <Route path="/group/grouplist" element={<ProtectedRoute element={<GroupList />} />} />
        <Route path="/group/userchat" element={<ProtectedRoute element={<UserChat />} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
